import type { FC } from "react";

import { Form } from "@/ui/components/form/Form";
import { InputField } from "@/ui/components/form/Input/InputField";
import { InputError } from "@/ui/components/form/InputError";
import { Label } from "@/ui/components/form/Label";
import { Column } from "@/ui/components/layout/Column";
import { Grid } from "@/ui/components/layout/Grid";
import { Inline } from "@/ui/components/layout/Inline";
import { Button } from "@/ui/components/primitives/Button";
import { cn } from "@/ui/lib/utils";

import type {
  TInlineFormProps,
} from "@/ui/components/form/InlineForm/InlineForm.config";

export const InlineForm: FC<TInlineFormProps> = ({
  label,
  input,
  onSubmit,
  error,
  button,
  disabled,
  className,
}) => {
  const {
    text: buttonText,
    disabled: isButtonDisabled,
    variant = "tertiary",
    ...buttonProps
  } = button;

  return (
    <Form data-component="InlineForm" onSubmit={onSubmit}>
      <Grid gap="3">
        <Column>
          <label className="grid" htmlFor={input.name}>
            <Label className="peer-disabled:opacity-70">
              { label }
            </Label>
          </label>
        </Column>
        <Column>
          <Inline>
            <div
              className={cn(
                "cursor-pointer grid gap-x-2",
                disabled && "cursor-not-allowed",
                className,
              )}
            >
              <InputField
                {...input}
                id={input.name}
                error={error}
                disabled={disabled || input.disabled}
              />
            </div>
            <Button
              {...buttonProps}
              type="submit"
              variant={variant}
              disabled={disabled || isButtonDisabled}
            >
              { buttonText }
            </Button>
          </Inline>
        </Column>
        { error ? (
          <Column>
            <InputError>{ error }</InputError>
          </Column>
        ) : null }
      </Grid>
    </Form>
  );
};

InlineForm.displayName = "InlineForm";
